export default {  
  starUserContainerDiv:{
    background: '#fff',
    borderBottom: data => '3px solid ' + data.mainColor,
    padding: '10px 20px',
    display: 'block'
  },
  starUserContainer:{
    display: 'block',
    maxWidth: '1170px',
    margin: '0 auto',
    textAlign: 'right',
  },
}